import { Button, Input, message } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useEffect, useRef, useState } from 'react';

import Loading from '../../../components/loading/Loading';
import { authAction } from '../../../redux/actions/authAction';
import { styles } from '../SignInPage.Styles';
import useDeviceWidth from '../../../hooks/useDeviceWidth';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import usePostData from '../../../api/hooks/usePostData';
import { useSelector } from 'react-redux';
import { userAction } from '../../../redux/actions/userAction';
import { utils } from '../../../utils';

function SignIn() {
    const deviceWidth = useDeviceWidth();
    const [signInStyles, setSignInStyles] = useState(utils.getDeviceStyles(styles, deviceWidth));
    const containerRef = useRef(null);
    const navigate = useNavigate();
    const user = useSelector((state) => state?.user?.details) || {};
    const { logo } = user?.client || {};
    useEffect(() => {
        setSignInStyles(utils.getDeviceStyles(styles, deviceWidth));
    }, [deviceWidth]);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [usernameError, setUsernameError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);

    const { postData, loading, error } = usePostData('/users/login');
    const dispatch = useDispatch();
    useEffect(() => {
        if (error) {
            message.error(error?.response?.data?.message || "An unexpected error has occurred. Try again later.");
        }
    }, [error]);
    useEffect(() => {
        const handleFocus = (e) => {
            if (containerRef.current) {
                const inputElement = e.target;
                const containerRect = containerRef.current.getBoundingClientRect();
                const inputRect = inputElement.getBoundingClientRect();

                if (inputRect.bottom > containerRect.bottom) {
                    containerRef.current.scrollTop = inputElement.offsetTop - containerRect.top;
                }
            }
        };

        document.addEventListener('focusin', handleFocus);
        return () => {
            document.removeEventListener('focusin', handleFocus);
        };
    }, []);

    const handleUsernameChange = (e) => {
        setUsername(e.target.value);
        setUsernameError(false);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        setPasswordError(false);
    };

    const handleSignIn = async () => {
        if (!isLoginDetailValid()) {
            setUsernameError(!isUsernameValid());
            setPasswordError(!isPasswordValid());
        } else {
            try {
                const result = await signInUser();
                if (result.status === 200) {
                    const { role, token, name, email, phone, events } = result;
                    dispatch(userAction({
                        ...user,
                        type: 'admin',
                        token,
                        name,
                        role,
                        email,
                        phone,
                        events
                    }));
                    dispatch(authAction({
                        isAdminAuthenticated: true,
                        isGuestAuthenticated: false,
                    }));
                    navigate('/article-editor');
                } else {
                    message.error(result.message);
                    setUsername('');
                    setPassword('');
                }
            } catch (error) {
                message.error("An error occurred while logging you in. Please try again later or contact support.");
                setUsername('');
                setPassword('');
            }
        }
    };

    const isUsernameValid = () => username.length > 0;
    const isPasswordValid = () => password.length > 0;
    const isLoginDetailValid = () => isUsernameValid() && isPasswordValid();

    const signInUser = async () => {
        try {
            const result = await postData({ 
                username: username.trimEnd(), 
                password: password.trimEnd()
            });
            return result;
        } catch (error) {
            return { success: false };
        }
    };

    return (
        <>
            
            {loading && <Loading message={'Signing you in...'} />}
            {!loading && (
                <div ref={containerRef} style={{ overflowY: 'auto', height: '100%' }}>
                    <div direction="vertical" style={signInStyles.container}>
                        <img
                            src={(logo && utils.isImageUrl(logo)) ? logo : require('../../../assets/iyk-logo.png')}
                            alt="chooseRole"
                            style={signInStyles.image}
                        />
                        <h3 style={signInStyles.h2}>IYK Admin Login</h3>
                        <div style={{
                            ...signInStyles.input
                        }}>
                            <h5 style={{ margin: 0, padding: 0, fontWeight: 500, fontSize: 16 }}>Username</h5>
                            <Input
                                status={usernameError ? "error" : ""}
                                placeholder="Username"
                                style={{
                                    ...signInStyles.input,
                                    width: '100%',
                                    marginTop: 13
                                }}
                                value={username}
                                onChange={handleUsernameChange}
                            />
                        </div>
                        <div style={signInStyles.input}>
                            <h5 style={{ margin: 0, padding: 0, fontWeight: 500, fontSize: 16 }}>Password</h5>
                            <Input.Password
                                placeholder="Password"
                                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                style={{
                                    ...signInStyles.input,
                                    width: '100%'
                                }}
                                value={password}
                                onChange={handlePasswordChange}
                                status={passwordError ? "error" : ""}
                            />
                        </div>
                        <Button style={signInStyles.button} onClick={handleSignIn}>
                            Sign In
                        </Button>
                        {/* <div style={signInStyles.aDiv}>
                            <span style={signInStyles.a} >Forgot password? <Link to="/reset-password" style={signInStyles.a}>Reset</Link></span>
                            <span style={signInStyles.a}>Don't have an account? <Link to="/sign-up" style={signInStyles.a}>Sign Up</Link></span>
                        </div> */}
                    </div>
                </div>
            )}
            {/* {showOverlay && (
                <Overlay onClose={() => setShowOverlay(false)} id={"signi-in-failure-overlay"} style={{ width: '80%' }} >
                    <h2 style={{ margin: 0 }}>Error:</h2>
                    <h3 style={{ fontWeight: '400' }}>{overlayMessage}</h3>
                    <Button
                        onClick={() => setShowOverlay(false)}
                        style={{ ...styles.overlayButton, backgroundColor: 'black', color: 'white' }}
                    >
                        OK
                    </Button>
                </Overlay>
            )} */}
        </>
    );
}

export default SignIn;
